/** Format whole seconds as MM:SS for coworking overlays/admin. */
export function formatCoworkingMmss(totalSeconds) {
  const total = Math.max(0, Math.floor(Number(totalSeconds) || 0));
  const minutes = Math.floor(total / 60);
  const seconds = total % 60;
  return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
}

function parseIsoMs(value) {
  if (!value) return null;
  const ms = Date.parse(String(value));
  return Number.isFinite(ms) ? ms : null;
}

/**
 * Derive live remaining seconds from a public timer payload.
 * Prefers ends_at + server_now skew so overlay polls do not stutter.
 */
export function remainingFromTimer(timer, nowMs = Date.now()) {
  if (!timer) return 0;
  const status = String(timer.status || "idle");
  const stored = Math.max(0, Math.floor(Number(timer.remaining_seconds) || 0));
  if (status !== "running") return stored;

  const endsAtMs = parseIsoMs(timer.ends_at);
  if (endsAtMs != null) {
    const serverNowMs = parseIsoMs(timer.server_now);
    const skewMs = serverNowMs != null ? serverNowMs - nowMs : 0;
    return Math.max(0, Math.ceil((endsAtMs - (nowMs + skewMs)) / 1000));
  }
  return stored;
}

export function progressFromTimer(timer, remainingSeconds) {
  const duration = Math.max(1, Math.floor(Number(timer?.duration_seconds) || remainingSeconds || 1));
  const remaining = Math.max(0, Math.floor(Number(remainingSeconds) || 0));
  return Math.max(0, Math.min(1, 1 - remaining / duration));
}
